import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type { ITransferPricingDocumentationKindsResponse } from './types';

/** The kinds, statuses and fiscal years a page presents, with their wording. Pass null to skip the request. */
export const useTransferPricingDocumentationKinds = (
  companyId: number | null
) => {
  const { data, error, isLoading, mutate } =
    useSWR<ITransferPricingDocumentationKindsResponse>(
      companyId === null
        ? null
        : TransferPricingDocumentationRequestHelper.kindsPath(companyId),
      SWRFetcher({ method: 'GET' })
    );

  return { kindsResponse: data ?? null, isLoading, error, mutate };
};
